import axios from "axios";
import { getBaseUrl, getPhpUrl, getBasicUrls } from "./config";
import { PT_SCHOOL_LOGIN } from "./keys";
import LoginUserHelper from "@/util/LoginUserHelper";
// import { message } from "antd";
import qs from "qs";
import { clearLocalStorage } from "./util";
const Env = getBasicUrls().env;
console.log(Env, 'Env');
function loginOut() {
  console.log(999999123)
  setTimeout(() => {
    LoginUserHelper.goBackLogin()  
  }, 1000);
}
axios.withCredentials = true;
axios.defaults.baseURL = getBaseUrl();
axios.defaults.headers.post["Content-Type"] = "application/json; charset=UTF-8";
axios.interceptors.request.use(
  function(config) {
    let token = LoginUserHelper.getUserToken()
    const {campusId,id} = LoginUserHelper.getUserInfo()
    if (
      config.url.indexOf("/user/login") === -1 &&
      config.url.indexOf("/user/getCode") === -1 &&
      config.url.indexOf("user/resetPassword") === -1 &&
      !token
    ) {
      loginOut();
    }
    if (
      (config.url.indexOf("/user/login") === -1 &&
        config.url.indexOf("user/resetPassword") === -1 &&
        window.location.href.indexOf("/ssologin") === -1) ||
      config.url.indexOf("/user/loginOut")
    ) {
      //   config.headers.common["Authorization"] = `${token}`;
      config.headers.Authorization = `${token}`;
      config.headers['songshu-uid'] = `${id || campusId || ''}`;
    }
    // if(config.url.indexOf("https://agent-api-test.classba.cn") !== -1){
    //   config.headers.Authorization = `eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxODA3MSIsImlhdCI6MTc0MTIyOTAzNiwiZXhwIjoxNzQxMjc2Nzk5fQ.TWoubAfTt0X2GkQt8mZqqYbuNAvuSuv7JMEwRUZmMaw`;
    //   config.headers['songshu-uid'] = `${id || campusId || ''}`;
    // }
    return Promise.resolve(config);
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    // 获取token接口不校验，直接返回
    if (response.config?.url.indexOf("token") !== -1) {
      return Promise.resolve(response.data);
    }
    // 登录失效
    if (
      response.data &&
      (response.data.code === -1 || response.data.code === 1000)
    ) {
      loginOut();
    } else if (response.data.code === -2) {
      loginOut();
    }
    let retData;
    if (response.data.code === -1) {
      // console.log(response, 'response.data');
      
      retData = {
        ...response.data,
        message: "当前登录状态失效 请重新登录"
      };
    } else if (response.data.code === 500) {
      // console.log(response, 'response.data');

      retData = {
        ...response.data,
        message: "服务器开小差了，请稍后重试！"
      };
    } else {
      retData = {
        ...response.data
      };
    }
    return Promise.resolve(retData);
  },
  function(error) {
    // 获取token接口不校验，直接返回
    if (
      error.response &&
      error.response.data &&
      (error.response.data.code === -1 || error.response.data.code === 1000)
    ) {
      loginOut();
    }
    // message.warning("服务器开小差了，请稍后重试！");
    console.log(error);
    return Promise.reject(error);
  }
);

class CRMAxios {
  constructor(options = {}) {
    this.options = options;
  }
  request(options) {
    return axios.request(options);
  }
  get(url, options = {}) {
    return this.request({
      url: url,
      params: {
        ...options
      }
    });
  }
  phpGet(url, options = {}) {
    return this.request({
      url: getPhpUrl() + url,
      params: {
        ...options
      }
    });
  }
  post(url, data, options = {}) {
    if (data instanceof Object) {
      data = JSON.stringify(data);
    }
    return this.request({
      method: "post",
      url,
      data,
      ...options
    });
  }
  phpPost(url, data, options = {}) {
    if (data instanceof Object) {
      data = JSON.stringify(data);
    }
    return this.request({
      method: "post",
      url: getPhpUrl() + url,
      data,
      ...options
    });
  }
}
const instanceAxios = new CRMAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);
export const phpPost = instanceAxios.phpPost.bind(instanceAxios);
export const phpGet = instanceAxios.phpGet.bind(instanceAxios);
